<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>
 

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <toolbar_visualizar
        v-if="form.id != null && form.id != undefined"
        :item="toolbar"
        grafico="1"
        :onGrafico="onGrafico"
      ></toolbar_visualizar>
   
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Auditoria Técnica</h4>
            </div>
          </md-card-header>

          <md-card-content v-if="!loading">
 <div class="md-layout" v-if="show_message_bloquear_edicao">
      <div class="alert alert-info"><b>Atenção:</b> auditoria publicada e bloqueada para edição.</div>
    </div>

            <div class="md-layout" v-if="form.id != null">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">ID</label>
              <div class="md-layout-item md-size-15 md-xsmall-size-70" v-if="form.id != null">
                <md-field>{{form.id}}</md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Data/Hora da Auditoria</label>
              <div class="md-layout-item md-size-20 md-xsmall-size-70">
                <md-field>
                  <DatepickerHour v-model="data" id_data="data_inspecao" id_hora="data_hora" v-if="false"></DatepickerHour>
                  <DatepickerHour2 v-model="form.data" id_data="data_inspecao" id_hora="data_hora" ref="datepicker_data_inspecao"></DatepickerHour2>
                </md-field>

                <span class="error_input">{{ getErrors('data_inspecao') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Auditoria acompanhada por</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="audit"
                    type="text"
                    placeholder="audit"
                    maxlength="300"
                    v-model="form.audit"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('audit') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cliente / Estabelecimento</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="sel_id_cliente"
                    :options="items_clientes"
                    v-model="form.id_cliente"
                    :searchable="true"
                    language="pt-BR"
                    :onChange="loadUnidade"
                    :placeholder="placeholder_cliente"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_cliente') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Unidade</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select_unidade"
                    :options="items_unidade"
                    v-model="form.id_estabelecimento"
                    :searchable="true"
                    language="pt-BR"
                    :placeholder="placeholder_unidade"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_estabelecimento') }}</span>
              </div>
            </div>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Responsável Controlare</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select_profissional"
                    :options="items_profissional"
                    v-model="form.id_resp_controllare"
                    :searchable="true"
                    language="pt-BR"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_resp_controllare') }}</span>
              </div>

              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Responsável Local</label>
              <div class="md-layout-item md-size-35 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_resp_local"
                    type="text"
                    placeholder="Responsável Local"
                    v-model="form.responsavel_local"
                    maxlength="300"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('responsavel_local') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label
                class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label"
              >Escolha o modelo de Check List para a inspeção</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select_modelo"
                    :options="items_modelo_checklist"
                    :onChange="change_modelo"
                    v-model="form.id_modelo"
                    :searchable="true"
                    language="pt-BR"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_modelo') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Observações</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <md-textarea style="height: 30px" height="30px" v-model="form.obs"></md-textarea>
                </md-field>

                <span class="error_input">{{ getErrors('obs') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Status</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <campo_status v-if="show_botao_publicar" v-model="form.publicado"></campo_status>

                  <md-select v-model="form.publicado" v-if="false" name="publicado" id="publicado">
                    <md-option
                      v-for="(item,index) in items_status"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">data_cadastro</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <datepicker2 v-model="form.data_cadastro"></datepicker2>
                  <datepicker v-if="false"
                    format="dd/MM/yyyy"
                    :typeable="true"
                    inputClass="md-input"
                    name="data_validade"
                    v-model="data_cadastro"
                    :language="language_date"
                    calendar-button-icon-content="event"
                    :input="datepicker_inputchanged"
                  ></datepicker>
                </md-field>

                <span class="error_input">{{ getErrors('data_cadastro') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">id_cadastrador</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_cadastrador"
                    type="text"
                    placeholder="id_cadastrador"
                    v-model="form.id_cadastrador"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('id_cadastrador') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">nome_cadastrador</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="nome_cadastrador"
                    type="text"
                    placeholder="nome_cadastrador"
                    v-model="form.nome_cadastrador"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('nome_cadastrador') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">nota_final</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="nota_final"
                    type="text"
                    placeholder="nota_final"
                    v-model="form.nota_final"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('nota_final') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">parecer_final</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="parecer_final"
                    type="text"
                    placeholder="parecer_final"
                    v-model="form.parecer_final"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('parecer_final') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">emails_lista</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="emails_lista"
                    type="text"
                    placeholder="emails_lista"
                    v-model="form.emails_lista"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('emails_lista') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Referência</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="referencia"
                    type="text"
                    placeholder="Referência"
                    v-model="form.referencia"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('referencia') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">seq_ano_mes_cliente</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="seq_ano_mes_cliente"
                    type="text"
                    placeholder="seq_ano_mes_cliente"
                    v-model="form.seq_ano_mes_cliente"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('seq_ano_mes_cliente') }}</span>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout" v-if="show_checklist_items">
        <div class="md-layout-item md-size-100">
          <comp_inspecao_item_cad
            v-if="form.id_modelo != null && form.id_modelo != undefined && parseInt( form.id_modelo) > 0 "
            :id_pai="form.id"
            :id_modelo_checklist="form.id_modelo"
            v-model="inspecao_items" :p_enable_edit="!disableButton"
            :change_itens="change_itens"
          ></comp_inspecao_item_cad>
        </div>
      </div>

      <div class="md-layout-item md-size-100">
        <div class="md-layout-item md-size-100" style="text-align: right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar"
          >Salvar</md-button>

          <botao_publicar :onClick="salvar" v-if="show_botao_publicar" :disableButton="false" :status="form.publicado"></botao_publicar>

          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir"
          >Excluir</md-button>
        </div>
      </div>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>
    </div>
    <modal v-if="form != null && show_grafico" @close="onCloseModal" class="md-size-75">
      <div slot="body">
        <grafico_inspecao v-bind:id="form.id"></grafico_inspecao>
      </div>
    </modal>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/InspecaoService";
import serviceCliente from "../../../services/ClienteService";
import serviceEstabelecimento from "../../../services/EstabelecimentoService";
import serviceNutricionista from "../../../services/NutricionistaService";
import serviceChecklist from "../../../services/ModeloChecklistService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import Util from "../../../library/Util";
import Alerta from "../../../library/Alerta";

import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";
import datepicker2 from "../../../components/Rend/datepicker2";

import DatepickerHour from "../../../components/Rend/DatepickerHour";
import DatepickerHour2 from "../../../components/Rend/DatepickerHour2";

import CardCadastro from "../../../components/CardCadastro";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import comp_inspecao_item_cad from "../inspecao_item/comp_inspecao_item_cad";
import $ from "jquery";
import toolbar_visualizar from "../../area/components/toolbar_visualizar";
import campo_status from "../../components/campo_status";
import botao_publicar from "../../components/botao_publicar";
import grafico_inspecao from "../../area/auditoria/grafico_inspecao";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    Datepicker,
    datepicker2,
    CardCadastro,
    vue_select,
    DatepickerHour,
    DatepickerHour2,
    comp_inspecao_item_cad,
    toolbar_visualizar,
    grafico_inspecao,
    campo_status,
    botao_publicar
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  watch: {
    id_cliente(val) {
      // if ( this.montado ){
      //     this.loadUnidade();
      //  }
    }
  },
  //:change="loadUnidade"
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],

      show_perfil: false,
      file_upload: null,

      id_cliente: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,
      show_checklist_items: false,

      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true,
      show_botao_publicar: true,

      data: null,
      data_cadastro: null,

      language_date: ptBR,
      items_clientes: [],
      items_unidade: [],
      items_profissional: [],
      items_modelo_checklist: [],
      items_status: service.getListStatus(),

      inspecao_items: [],

      montado: false,
      toolbar: null,
      placeholder_cliente: "..Carregando clientes",
      placeholder_unidade: "Selecione o cliente",

      show_grafico: false,
      show_message_bloquear_edicao: false
    };
  },
  mounted() {
    let user = JSON.parse(window.obj_user.getUser());
    let self = this;

    this.show_checklist_items = false;
    this.form = service.getModel();

    this.configureMessages();

    serviceCliente.getList2("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(
        response.data.data,
        "id",
        "nome"
      );

      self.placeholder_cliente = "Cliente (digite para pesquisar) ";
    });

    this.loadProfissional();
    this.loadModelo();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    this.disableButton = true;

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      
      self.show_botao_publicar = false;
      service.getById(this.id_load).then(function(response) {
        if (response.data.data != null && response.data.data != undefined) {
          self.form = response.data.data;
        } else {
          self.form = response.data.item;
        }

        self.montado = true;

        self.id_cliente = self.form.id_cliente;
        self.toolbar = response.data.toolbar;

        /* if (self.form.data != null) {
          self.data = self.getApiDateHour(self.form.data);
          // console.log("data convertida? " + self.form.data);
        }
        if (self.form.data_cadastro != null) {
          var intData = self.getApiDateInt(self.form.data_cadastro);

          self.data_cadastro = new Date(intData);
        } */

        setTimeout( () => self.loading = false, 100 );

        //self.loading = false;
        self.disableButton = false;
        self.loadUnidade();
        self.show_botao_publicar = true;

        var perfil_codigo = "";

        if( user.perfil_codigo ){
          perfil_codigo =  user.perfil_codigo.toString();
        }


           if (self.form.publicado != null &&
              parseInt(self.form.publicado) == 1 &&
              perfil_codigo != "1" &&
              user.perfil.toLowerCase().indexOf("administrador") < 0 &&
              user.perfil.toLowerCase().indexOf("supervisor") < 0
            ) {
              self.disableButton = true;
              self.show_message_bloquear_edicao  = true;
              self.show_botao_publicar = false;
            }

            
        self.show_checklist_items = true;
      });

    
    } else {
      this.loading = false;
      this.disableButton = false;
      self.montado = true;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "inspecao",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    setVisibleButtons(){
    let user = JSON.parse(window.obj_user.getUser());
        if (this.form.publicado != null &&
              parseInt(this.form.publicado) == 1 &&
              user.perfil.toLowerCase().indexOf("administrador") < 0 &&
              user.perfil.toLowerCase().indexOf("supervisor") < 0
            ) {
              this.disableButton = true;
              this.show_message_bloquear_edicao  = true;
            }
    },
    onCloseModal() {
      this.show_grafico = false;
    },
    onGrafico(item, tipo) {
      this.show_grafico = true;
    },

    change_itens(items) {
      //   this.inspecao_items = items;
    },

    change_modelo() {
      //console.log("Changed modelo?");
      var self = this;
      this.show_checklist_items = false;
      setTimeout(function() {
        (self.show_checklist_items = true), 100;
      });
    },

    loadUnidade() {
      var self = this;

      console.log("unidade?");
      this.id_cliente = this.form.id_cliente;

      if (this.id_cliente == null) {
        self.items_unidade = [];
        self.placeholder_unidade = "Selecione o cliente";
        return false;
      }

      self.placeholder_unidade = "..Carregando unidades";
      serviceEstabelecimento
        .getListByParent("cliente", this.id_cliente)
        .then(function(response) {
          self.items_unidade = Util.getListToSelect(
            response.data,
            "id",
            "nome"
          );
          self.placeholder_unidade = "Unidades (digite para pesquisar)";
        });
    },

    loadProfissional() {
      var self = this;

      serviceNutricionista.getList("", "nome", "asc").then(function(response) {
        self.items_profissional = Util.getListToSelect(
          response.data,
          "id",
          "nome"
        );
      });
      //items_profissional
    },
    loadModelo() {
      var self = this;
      serviceChecklist
        .getList({ order: "nome", order_type: "asc" })
        .then(function(response) {
          self.items_modelo_checklist = Util.getListToSelect(
            response.data,
            "id",
            "nome"
          );
        });
    },

    datepicker_inputchanged(value) {},

    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {},

    configureMessages() {
      const dict = {
        data_inspecao: {
          required: "Informe a data de auditoria"
        },
        id_cliente: {
          required: "Selecione o cliente!",
          internal: true
        },

        id_estabelecimento: {
          required: "Selecione a unidade",
          internal: true
        },
        id_modelo: {
          required: "Selecione o modelo de checklist",
          internal: true
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar(prop_status, prop_nome_perfil) {
      var self = this;
      let bl_edicao  = true;

        this.show_botao_publicar = false;
      if ( self.form.id == null || self.form.id == undefined ){
        bl_edicao = false;

      }

      self.form.categorias = this.inspecao_items;

      //this.form.id_cliente = this.id_cliente;

      if (!this.validar()) return false;

      /*
      var data = Util.BrDateToJavascript(
        this.getInputByName("data_inspecao").value
      );
      self.data = new Date(data);
      //self.data_cadastro = Util.dateToBd(  self.form.data_cadastro );

      self.form.data = Util.dateToBd(self.data);
      self.form.hora = $("#data_hora").val();

      var hora = $("#data_hora").val();
      if (self.form.data != null && hora != "" && hora.length == 5) {
        var ar = hora.split(":");

        var data = new Date(
          this.data.getFullYear(),
          this.data.getMonth(),
          this.data.getDate(),
          parseInt(ar[0]),
          parseInt(ar[1])
        );

        self.form.data = Util.dateHourToBd(data);
      } */

      self.form.data = this.$refs["datepicker_data_inspecao"].GetDataHora();

      self.msg_status = "Salvando..";
      self.loading = true;

      if (this.form.publicado == null) {
        this.form.publicado = 0;
      }

      console.log("prop_status ? " + typeof prop_status);
      console.log(prop_status);

      if (
        prop_status != null &&
        prop_status != undefined &&
        typeof prop_status == "number"
      ) {
        this.form.publicado = prop_status;
      }

      if (! bl_edicao ){
          this.show_checklist_items = false;
      }

      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "Auditoria salva com sucesso!";

          //self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";


          self.form = item;

          //if (self.form.data != null) {
          //  self.data = self.getApiDateHour(self.form.data);
         // }

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
          if (! bl_edicao ){
            self.show_checklist_items = true;

          }
          self.show_botao_publicar = true;

          self.setVisibleButtons();
          self.loading = false;
          setTimeout(() => self.clear_message(), 6000 );
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;

      if (
        this.form == null ||
        this.form.id == null ||
        this.form.id == undefined
      )
        return false;

      Alerta.confirm(
        "Atenção",
        "Deseja realmente excluir esta auditoria?",
        "question",
        function() {
          self.msg_status = "Excluindo..";
          self.loading = true;

          var fn_return = function(response) {
            var retorno = response.data;
            if (self.onSave != null && self.onSave != undefined) {
              self.onSave(retorno, "delete");
            }
            self.msg_status = "Carregando..";
            self.loading = false;
            self.botao_voltar();
            //Alerta.show("Sucesso!","Auditoria excluída com sucesso!", "success", )
          };

          service.delete(self.form.id).then(fn_return);
          //	obj_api.call_delete("cliente", this.id, fn_return);
        },
        null
      );
    },
    clear_message() {
      this.show_message = "off";
      //clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>
